import clsx from 'clsx'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import type { SalesTypeItemProps } from './type'

import { DeleteFilledIcon } from '@/components/icons/DeleteFilled'
import {
  FormInputHorizontalLayout,
  FormFieldSelect,
  Icon,
} from '@/components/ui'
import { useSalesTypesMaster } from '@/stores'

export const SalesTypeItem = ({
  index,
  showRemove = true,
  control,
  onClickRemove,
  onAfterChange,
}: SalesTypeItemProps) => {
  const { salesTypesMaster } = useSalesTypesMaster()
  const { t } = useTranslation()

  const salesTypeOptions = useMemo(
    () =>
      salesTypesMaster.map(({ salesTypeCode, salesTypeName }) => ({
        label: salesTypeName,
        value: salesTypeCode,
      })) ?? [],
    [salesTypesMaster]
  )

  return (
    <div className={clsx('tw-mt-1')}>
      <FormInputHorizontalLayout alignVertical="center">
        {showRemove ? (
          <button onClick={onClickRemove}>
            <Icon
              icon={DeleteFilledIcon}
              size={'2xl'}
              color={'primary'}
              className={clsx(
                'tw-cursor-pointer',
                'hover:tw-opacity-hover',
                'tw-transition-opacity'
              )}
            />
          </button>
        ) : (
          <span className={clsx('tw-w-6')} />
        )}

        <div className={clsx('tw-flex-1')}>
          <div className={clsx('tw-items-center tw-gap-x-2 lg:tw-flex')}>
            <div className={clsx('tw-flex tw-items-center tw-gap-x-2')}>
              <div className="tw-min-w-[106px] tw-flex-1">
                <FormFieldSelect
                  showLabel={false}
                  height="md"
                  showError={false}
                  name={`salesTypeCodes.${index}`}
                  control={control}
                  options={salesTypeOptions}
                  buttonLabel={t('common.placeholder.select')}
                  onAfterChange={onAfterChange}
                />
              </div>
            </div>
          </div>
        </div>
      </FormInputHorizontalLayout>
    </div>
  )
}
